var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { I18NLink } from "../../../I18N";
import { Icon } from "../../../UI";

import api from "../../../Search/SearchAPI";

const processesIds = ['58b2f3a35d59f31e1345b48a'];
const provisionalMeasuresIds = ['58b2f3a35d59f31e1345b4a4'];
const documentsIds = [
'58b2f3a35d59f31e1345b4ac',
'58b2f3a35d59f31e1345b471',
'58b2f3a35d59f31e1345b482',
'58b2f3a35d59f31e1345b479'];


export class cejilChart001 extends Component {
  getData() {
    api.search({ limit: 0 }).then((results) => {
      this.setState({ data: results.aggregations.all });
    });
  }

  conformLibraryLink(types, link) {
    const escapedValues = types.map((t) => `%27${t}%27`);
    if (link && link.indexOf('/library/') !== -1) {
      return link.substring(link.indexOf('/library/'), link.length);
    }
    return `/library/?q=(order:desc,sort:creationDate,types:!(${escapedValues.join(
      ','
    )}),userSelectedSorting:!t)`;
  }

  getCount(ids) {
    return ids.reduce((count, id) => {
      const bucket = this.state.data.types.buckets.find((b) => b.key === id);
      return count + (bucket ? bucket.filtered.doc_count : 0);
    }, 0);
  }

  componentDidMount() {
    this.getData();
  }

  render() {
    const { title = '', buttons = [], links = [] } = this.props;
    const Loader = /*#__PURE__*/_jsx(Icon, { icon: "spinner", pulse: true, fixedWidth: true });

    let processesCount = Loader;
    let provisionalMeasuresCount = Loader;
    let documentsCount = Loader;

    if (this.state && this.state.data) {
      processesCount = this.getCount(processesIds);
      provisionalMeasuresCount = this.getCount(provisionalMeasuresIds);
      documentsCount = this.getCount(documentsIds);
    }

    return /*#__PURE__*/(
      _jsx("div", { className: "hero" }, void 0, /*#__PURE__*/
      _jsx("h1", {}, void 0, title), /*#__PURE__*/
      _jsx("div", { className: "hero-stats" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, {
        to: this.conformLibraryLink(processesIds, links.length && links[0] ? links[0] : null) }, void 0, /*#__PURE__*/

      _jsx("h2", {}, void 0, processesCount), /*#__PURE__*/
      _jsx("span", {}, void 0, buttons[0])
      ), /*#__PURE__*/
      _jsx(I18NLink, {
        to: this.conformLibraryLink(
          provisionalMeasuresIds,
          links.length && links[1] ? links[1] : null
        ) }, void 0, /*#__PURE__*/

      _jsx("h2", {}, void 0, provisionalMeasuresCount), /*#__PURE__*/
      _jsx("span", {}, void 0, buttons[1])
      ), /*#__PURE__*/
      _jsx(I18NLink, {
        to: this.conformLibraryLink(documentsIds, links.length && links[2] ? links[2] : null) }, void 0, /*#__PURE__*/

      _jsx("h2", {}, void 0, documentsCount), /*#__PURE__*/
      _jsx("span", {}, void 0, buttons[2])
      )
      )
      ));

  }
}








export function mapStateToProps({ templates, thesauris }) {
  return { templates, thesauris };
}

export default connect(mapStateToProps)(cejilChart001);